import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import icons, {faImage} from '@fortawesome/fontawesome-free-solid';
import './pageElements.scss';
import transparentBg from './images/transparentBg.jpg';

export class PageTitle extends Component {
    renderIcon() {
        const icon = this.props.icon;
        if(icon) return (
            <span>
                <FontAwesomeIcon icon={icons[icon]}/>&nbsp;
            </span>
        )
    }
    render() {
        
        return (
            <div className="pageTitle">
                {this.renderIcon()}
                {this.props.children}
            </div>
        )
    }
}

export class BoxTitle extends PageTitle {
    render() {
        return (
            <div className="boxTitle">
                {this.renderIcon()}
                {this.props.children}
            </div>
        )
    }
}

export class BoxSide extends Component {
    render() {
        return (
            <div className={`box-2`}>
                {this.props.children}
            </div>
        )
    }
}

export class Box extends Component {
    render() {
        const col = this.props.col || 1;
        const {className} = this.props;

        return (
            <div className={`box box-${col} ${className? className : ''}`} id={this.props.id}>
                {this.props.children}
            </div>
        )
    }
}

export class Container extends Component {
    render() {
        const {className, id} = this.props;
        return (
            <div id={id} className={`container ${className ? className : ''}`}>
                {this.props.children}
            </div>
        )
    }
}

export class TabsNavigation extends Component {
    render() {
        const {className, level, children} = this.props;
        const classes = level == 2 ? ' level2' : '';
        return (
            <div className={`pageTabsNav${classes} ${className ? className : ''}`}>
                {children}
            </div>
        )
    }
}

export class TopFixed extends Component {
    render() {
        const classes = this.props.numOfTabsNav == 2 ? ' doubleTabsNav' : '';

        return (
            <div className={`pageTopFixed${classes}`}>
                {this.props.children}
            </div>
        )
    }
}

export class ImagePreview extends Component {
    render() {
        const text = this.props.text || "";
        const image = this.props.image || false;
        const imgBg = image ? {'backgroundImage': `url(${transparentBg}`} : {}

        return (
            <div className={`imagePreview ${image ? 'hasPreviewImage': ''}`}>
                <div className="previewBg" style={imgBg}>
                    {image && <img className="previewImage" src={image} alt=""/>}
                    <div className="noPreviewImage">
                        <FontAwesomeIcon icon={faImage} />
                        <span className="noPreviewImageText">{text}</span>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PageTemplate/PageElements.jsx